import AdminWorkerDetails from "./AdminWorkerDetails";

export default AdminWorkerDetails;
